import { fetchDispatch } from 'data/helpers'

export const FETCH_CONVERSATION_LISTING_LOADING = 'chatbotConversations/FETCH_CONVERSATION_LISTING_LOADING'
export const FETCH_CONVERSATION_LISTING_SUCCESS = 'chatbotConversations/FETCH_CONVERSATION_LISTING_SUCCESS'
export const FETCH_CONVERSATION_LISTING_FAILURE = 'chatbotConversations/FETCH_CONVERSATION_LISTING_FAILURE'

export const FETCH_USER_LISTING_LOADING = 'chatbotConversations/FETCH_USER_LISTING_LOADING'
export const FETCH_USER_LISTING_SUCCESS = 'chatbotConversations/FETCH_USER_LISTING_SUCCESS'
export const FETCH_USER_LISTING_FAILURE = 'chatbotConversations/FETCH_USER_LISTING_FAILURE'

export const FETCH_USER_CONVERSATIONS_LOADING = 'chatbotConversations/FETCH_USER_CONVERSATIONS_LOADING'
export const FETCH_USER_CONVERSATIONS_SUCCESS = 'chatbotConversations/FETCH_USER_CONVERSATIONS_SUCCESS'
export const FETCH_USER_CONVERSATIONS_FAILURE = 'chatbotConversations/FETCH_USER_CONVERSATIONS_FAILURE'

export const FETCH_CONVERSATION_THREAD_LOADING = 'chatbotConversations/FETCH_CONVERSATION_THREAD_LOADING'
export const FETCH_CONVERSATION_THREAD_SUCCESS = 'chatbotConversations/FETCH_CONVERSATION_THREAD_SUCCESS'
export const FETCH_CONVERSATION_THREAD_FAILURE = 'chatbotConversations/FETCH_CONVERSATION_THREAD_FAILURE'

export const SET_SELECTED_CONVERSATION_ID = 'chatbotConversations/SET_SELECTED_CONVERSATION_ID'
export const SET_SELECTED_USER_ID = 'chatbotConversations/SET_SELECTED_USER_ID'

export const fetchConversationListing = ({ userEmail, feedbackFilter, contentSearch, page, pageSize } = {}) => {
  return async dispatch => {
    dispatch({ type: FETCH_CONVERSATION_LISTING_LOADING })
    try {
      const params = new URLSearchParams()
      if (userEmail) params.append('userEmail', userEmail)
      if (feedbackFilter) params.append('feedbackFilter', feedbackFilter)
      if (contentSearch) params.append('contentSearch', contentSearch)
      if (page) params.append('page', page)
      if (pageSize) params.append('pageSize', pageSize)
      const path = `/api/chatbot_conversations/conversations/listing?${params.toString()}`
      const response = await fetchDispatch({ path, method: 'GET' })
      dispatch({ type: FETCH_CONVERSATION_LISTING_SUCCESS, payload: response })
    } catch (error) {
      dispatch({ type: FETCH_CONVERSATION_LISTING_FAILURE, payload: error })
    }
  }
}

export const fetchUserListing = ({ userEmail, page, pageSize } = {}) => {
  return async dispatch => {
    dispatch({ type: FETCH_USER_LISTING_LOADING })
    try {
      const params = new URLSearchParams()
      if (userEmail) params.append('userEmail', userEmail)
      if (page) params.append('page', page)
      if (pageSize) params.append('pageSize', pageSize)
      const path = `/api/chatbot_conversations/users?${params.toString()}`
      const response = await fetchDispatch({ path, method: 'GET' })
      dispatch({ type: FETCH_USER_LISTING_SUCCESS, payload: response })
    } catch (error) {
      dispatch({ type: FETCH_USER_LISTING_FAILURE, payload: error })
    }
  }
}

export const fetchUserConversations = userId => {
  return async dispatch => {
    dispatch({ type: FETCH_USER_CONVERSATIONS_LOADING })
    try {
      const response = await fetchDispatch({
        path: `/api/chatbot_conversations/users/${userId}/conversations`,
        method: 'GET',
      })
      dispatch({ type: FETCH_USER_CONVERSATIONS_SUCCESS, payload: response })
    } catch (error) {
      dispatch({ type: FETCH_USER_CONVERSATIONS_FAILURE, payload: error })
    }
  }
}

export const fetchConversationThread = conversationId => {
  return async dispatch => {
    dispatch({ type: FETCH_CONVERSATION_THREAD_LOADING, conversationId })
    try {
      const response = await fetchDispatch({
        path: `/api/chatbot_conversations/conversations/${conversationId}/thread`,
        method: 'GET',
      })
      dispatch({ type: FETCH_CONVERSATION_THREAD_SUCCESS, conversationId, payload: response })
    } catch (error) {
      dispatch({ type: FETCH_CONVERSATION_THREAD_FAILURE, conversationId, payload: error })
    }
  }
}

export const setSelectedConversationId = conversationId => ({
  type: SET_SELECTED_CONVERSATION_ID,
  payload: conversationId,
})

export const setSelectedUserId = userId => ({
  type: SET_SELECTED_USER_ID,
  payload: userId,
})

const initialState = {
  conversations: [],
  conversationsLoading: false,
  conversationsTotalCount: 0,
  users: [],
  usersLoading: false,
  usersTotalCount: 0,
  userConversations: [],
  userConversationsLoading: false,
  threads: {},
  threadLoading: {},
  threadError: {},
  selectedConversationId: null,
  selectedUserId: null,
}

export const chatbotConversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATION_LISTING_LOADING:
      return { ...state, conversationsLoading: true }
    case FETCH_CONVERSATION_LISTING_SUCCESS:
      return {
        ...state,
        conversationsLoading: false,
        conversations: action.payload.conversations ?? action.payload,
        conversationsTotalCount: action.payload.totalCount ?? 0,
      }
    case FETCH_CONVERSATION_LISTING_FAILURE:
      return { ...state, conversationsLoading: false }

    case FETCH_USER_LISTING_LOADING:
      return { ...state, usersLoading: true }
    case FETCH_USER_LISTING_SUCCESS:
      return {
        ...state,
        usersLoading: false,
        users: action.payload.users ?? action.payload,
        usersTotalCount: action.payload.totalCount ?? 0,
      }
    case FETCH_USER_LISTING_FAILURE:
      return { ...state, usersLoading: false }

    case FETCH_USER_CONVERSATIONS_LOADING:
      return { ...state, userConversationsLoading: true }
    case FETCH_USER_CONVERSATIONS_SUCCESS:
      return { ...state, userConversationsLoading: false, userConversations: action.payload }
    case FETCH_USER_CONVERSATIONS_FAILURE:
      return { ...state, userConversationsLoading: false }

    case FETCH_CONVERSATION_THREAD_LOADING:
      return {
        ...state,
        threadLoading: { ...state.threadLoading, [action.conversationId]: true },
        threadError: { ...state.threadError, [action.conversationId]: false },
      }
    case FETCH_CONVERSATION_THREAD_SUCCESS:
      return {
        ...state,
        threadLoading: { ...state.threadLoading, [action.conversationId]: false },
        threadError: { ...state.threadError, [action.conversationId]: false },
        threads: { ...state.threads, [action.conversationId]: action.payload },
      }
    case FETCH_CONVERSATION_THREAD_FAILURE:
      return {
        ...state,
        threadLoading: { ...state.threadLoading, [action.conversationId]: false },
        threadError: { ...state.threadError, [action.conversationId]: true },
      }

    case SET_SELECTED_CONVERSATION_ID:
      return { ...state, selectedConversationId: action.payload, threadError: {} }
    case SET_SELECTED_USER_ID:
      return { ...state, selectedUserId: action.payload }

    default:
      return state
  }
}
